<template>
  <div class="logistics-verification-list">
    <div class="logistics-verification-list-container">
      <div class="search-container">
        <div class="screen">
          <span class="screen-title">仓库名称：</span>
          <el-select clearable v-model="searchForm.warehouseId" placeholder="请选择仓库">
            <el-option v-for="item in warehouseList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <span class="screen-title">承运商：</span>
          <el-select v-model="searchForm.expressType" placeholder="请选择">
            <el-option v-for="item in expressList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <span class="screen-title">日期：</span>
          <el-date-picker v-model="searchForm.month" type="month" value-format="yyyy-MM"
            placeholder="选择月份"></el-date-picker>
          <el-button icon="el-icon-search" class="btn-blue" @click="onSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" class="btn-gray" @click="clearData">重置</el-button>
        </div>
      </div>
      <div class="table">
        <div class="table-top">
          <p class="table-top-title">物流核验记录</p>
          <div class="add-customer" @click="addLogisticsVerification">
            <span class="add-rectangle"></span>
            <span>创建</span>
          </div>
        </div>
        <el-table ref="table" :data="tableData" style="width: 100%" :header-cell-class-name="headerCellClassName">
          <el-table-column 
            v-for="(item, index) in tableTitleList" 
            :key="index" 
            :prop="item.prop" 
            :label="item.label"
            show-overflow-tooltip 
            :min-width="item.width"
            :class-name="item.alignment === 'right' ? `cell-right-align-width` : item.prop === 'statusVal' ? 'status-cell' : ''">
            <template slot-scope="scope">
              <div v-if="item.prop === 'statusVal'" :class="`status${scope.row.status}`" class="status">
                {{ scope.row[item.prop] }}
                <img v-if="item.prop === 'statusVal' && scope.row.status == 2" class="yellow-load"
                  src="~assets/images/yellow-load.png">
              </div>
              <div v-else style="
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;">
                {{ scope.row[item.prop] }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button class="btn-text" type="text" @click="lookDetails(scope.row)">详情</el-button>
              <el-button v-if="scope.row.status == 1" class="btn-red-text" type="text"
                @click="del(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <pagination-tpl :total="total" :currentPage="currentPage" :pageSize="pageSize"
            @queryChange="queryChange"></pagination-tpl>
        </div>
      </div>
    </div>

    <!-- 创建 -->
    <el-drawer title="创建" :visible.sync="drawer" :wrapperClosable="false" :before-close="handleCloseDrawer">
      <div class="logistics-verification-form-content">
        <el-form class="logistics-verification-form" ref="logisticsVerificationForm" :model="logisticsVerificationForm"
          :rules="rules">
          <el-form-item label="仓库" prop="warehouseId">
            <el-select class="white" clearable v-model="logisticsVerificationForm.warehouseId" placeholder="请选择仓库名称">
              <el-option v-for="item in warehouseList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="承运商" prop="expressType">
            <el-select v-model="logisticsVerificationForm.expressType" filterable clearable class="white"
              placeholder="请选择承运商">
              <el-option v-for="item in expressList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期" prop="date">
            <el-date-picker v-model="logisticsVerificationForm.date" type="month" value-format="yyyy-MM"
              placeholder="选择月份" clearable></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button class="btn-blue" @click="confirm('logisticsVerificationForm')">保存并核验</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import PaginationTpl from "components/base/PaginationTpl";
import expressMixins from "@/common/mixins/express.js"
import warehouseMixins from "@/common/mixins/warehouse.js"
import LogisticsVerification from "models/logistics-verification";
import { numsToRMBSymbolAndMillimeter, formaTimeToMinute } from "common/js/util";
export default {
  mixins: [warehouseMixins, expressMixins],
  components: {
    PaginationTpl
  },
  data() {
    return {
      searchForm: {
        warehouseId: '',
        expressType: '',
        month: ''
      },
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitleList: [
        { label: '仓库名称', prop: 'warehouseName', width: '', alignment: 'left' },
        { label: '承运商', prop: 'expressName', width: '', alignment: 'left' },
        { label: '账单日期', prop: 'billTime', width: '120', alignment: 'left' },
        { label: '创建日期', prop: 'createTime', width: '120', alignment: 'left' },
        { label: '核验金额', prop: 'amount', width: '', alignment: 'right' },
        { label: '状态', prop: 'statusVal', width: '', alignment: 'left' },
      ],
      statusObj: {
        1: '待核验',
        2: '核验中',
        3: '已核验',
      },
      drawer: false,
      logisticsVerificationForm: {
        warehouseId: '',
        expressType: '',
        date: ''
      },
      rules: {
        warehouseId: [
          { required: true, message: '请选择仓库', trigger: 'change' }
        ],
        expressType: [
          { required: true, message: '请选择承运商', trigger: 'change' }
        ],
        date: [
          { required: true, message: '请选择月份', trigger: 'change' }
        ]
      },
    }
  },

  created() {
    this.initWarehouse()
    this.initExpressList()
    this.initList()
  },

  methods: {
    /** 
     * @desc 物流核验列表
    */
    initList() {
      let billDate = this.searchForm.month ? this.searchForm.month:''
      let warehouseId = this.searchForm.warehouseId
      let expressType = this.searchForm.expressType
      let page = this.currentPage
      let data = {
        warehouseId,
        expressType,
        billDate,
        page
      }

      LogisticsVerification.getNewLogisticsVerificationList(data).then(res => {
        if (res.success) {
          let { items, pageSize, totalNum } = res.result
          let arr = []
          this.pageSize = pageSize;
          this.total = totalNum;
          items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.billTime = i.accountMonth
            obj.createTime = i.createTime?formaTimeToMinute(i.createTime):'/'
            obj.warehouseName = i.warehouseName
            obj.expressName = i.expressName
            obj.amount = i.accountAmount ? numsToRMBSymbolAndMillimeter(i.accountAmount):'/'
            obj.type = i.expressOrLogistics
            obj.processStep = i.processStep
            obj.status = i.status
            obj.statusVal = this.statusObj[i.status]
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },

    onSearch() {
      this.currentPage = 1;
      this.initList();
    },

    clearData() {
      this.searchForm.month = ''
      this.searchForm.warehouseId = ''
      this.searchForm.expressType = ''
    },

    addLogisticsVerification() {
      this.drawer = true
    },

    /** 
     * @desc 翻页
    */
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initList();
    },

    /**
     * @desc 表头添加类名处理数字右对齐
     */
    headerCellClassName({ columnIndex }) {
      if (columnIndex == 4) {
        return 'right-align'
      }
    },

    lookDetails(row) {
      let name = `核验详情_${row.expressName}（${row.billTime}）`
      this.$router.push({
        path: `/operate/finance/newLogisticsVerification/LogisticsVerificationDetails/${name}`,
        query: {
          logisticsVerificationId: row.id,
          type: row.type
        }
      })
    },


    /**
     * @desc 删除物流核验数据
     * @param {*} id 物流核验记录id
     */
    del(id) {
      this.$confirm("删除后不可恢复，是否继续？", "删除", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-red',
        cancelButtonClass: 'btn-gray'
      }).then(() => {
        LogisticsVerification.postDelLogisticsVerification(id).then(res => {
          if (res.success) {
            this.initList();
          } else {
            this.$message.error(res.message)
          }
        })
      });
    },

    handleCloseDrawer() {
      this.$refs['logisticsVerificationForm'].resetFields();
      this.drawer = false
    },

    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let warehouseId = this.logisticsVerificationForm.warehouseId
          let expressType = this.logisticsVerificationForm.expressType
          let accountMonth = this.logisticsVerificationForm.date
          let warehouseObj = this.warehouseList.find(item => { return item.id == warehouseId })
          let expressObj = this.expressList.find(item => { return item.id == expressType })
          let data = {
            warehouseId,
            warehouseName: warehouseObj.name,
            expressType,
            accountMonth,
            expressName: expressObj.name,
            expressOrLogistics: expressObj.type,
          }
          LogisticsVerification.postCreateLogisticsVerification(data).then(res => {
            if (res.success) {
              this.initList()
              this.handleCloseDrawer()
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style lang='scss'>
@import '@/assets/style/layout/finance/logistics-verification-list.scss';
</style>
